import RMModal, { RMModalProps } from 'components/modal/RMModal';
import './MergeIngredient.css';
import React, { useEffect, useState } from 'react';
import { MergeIngredientSection } from './MergeIngredientSection';
import {
  ExtendedIngredientDTO,
  IngredientDocStockDTO,
  IngredientStockDTO,
} from 'business/models/Models';
import _, { cloneDeep } from 'lodash';
import { MergeIngredientsProps } from '../IngredientConstants';
import { MergeIngredientType } from '../IngredientEnums';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { MergeStocks } from '../mergeStocks/MergeStocks';
import { setIngTableDataIndicator } from 'redux/reducers/ingredientTableReducer';
import { useRMDispatch } from 'redux/hooks';
import { useIngredientsDataIndicator } from 'redux/hooks/ingredients';
import {
  addMergeIngredient,
  getCombinedMergeIngIngTypes,
  getCombinedMergeTypes,
  MergeIngredientsButtons,
} from './MergeIngredientsUtils';
import { setMergingStocks, onClickMergeStock } from '../mergeStocks/MergeStockUtils';
import { FmlxModal, FmlxBackdropLoading } from 'fmlx-common-ui';

export const MergeIngredients = (props: MergeIngredientsProps) => {
  const { showModal, setShowModal, ingredients, setIngredients } = props;
  const [tempIngredient, setTempIngredient] = useState<ExtendedIngredientDTO>(
    new ExtendedIngredientDTO(),
  );
  const [mergeIngredient, setMergeIngredient] = useState<ExtendedIngredientDTO>(
    new ExtendedIngredientDTO(),
  );
  const [mergeIngredientType, setMergeIngredientType] = useState<MergeIngredientType>(
    MergeIngredientType.Ingredient1,
  );
  const [showStocksModal, setStocksShowModal] = useState<boolean>(false);
  const [matchedStocks, setMatchedStocks] = useState<IngredientDocStockDTO[]>([]);
  const [stocks, setStocks] = useState<IngredientDocStockDTO[]>([
    new IngredientDocStockDTO(),
    new IngredientDocStockDTO(),
  ]);
  const [stockIndex, setStockIndex] = useState<number>(0);
  const [matchedIngStocks, setMatchedIngStocks] = useState<{
    [key: string]: IngredientDocStockDTO[];
  }>();
  const [mergedAndDeletedStockIds, setMergedAndDeletedStockIds] = useState<{
    [key: string]: number;
  }>({});
  const [isMerging, setIsMerging] = useState(false);

  const dispatch = useRMDispatch();
  const ingTableDataIndicator = useIngredientsDataIndicator();
  useEffect(() => {
    if (showModal) {
      if (!ingredients[0] || !ingredients[1]) {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'Ingredient(s) has been updated externally.',
        );
        setShowModal(false);
        dispatch(setIngTableDataIndicator(ingTableDataIndicator + 1));
        return;
      }
      const mergeIng = new ExtendedIngredientDTO();
      mergeIng.types = getCombinedMergeTypes(ingredients);
      mergeIng.ingredientIngredientType = [];
      mergeIng.ingredientIngredientType = getCombinedMergeIngIngTypes(
        mergeIng,
        ingredients,
      );
      const combinedIngredients: IngredientStockDTO[] =
        ingredients[0].ingredientStock.concat(ingredients[1].ingredientStock);
      mergeIng.ingredientStock = _.uniq(combinedIngredients);
      setMergeIngredient(mergeIng);
      setTempIngredient(new ExtendedIngredientDTO());
    }
  }, [showModal]);

  const onClickButton = (value: MergeIngredientType) => {
    if (!ingredients[0] || !ingredients[1]) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Invalid ingredients data.',
      );
      return;
    }
    let tempIng = new ExtendedIngredientDTO();
    value === MergeIngredientType.Ingredient1
      ? (tempIng = cloneDeep(ingredients[0]))
      : value === MergeIngredientType.Ingredient2
      ? (tempIng = cloneDeep(ingredients[1]))
      : (tempIng = new ExtendedIngredientDTO());

    tempIng.types = getCombinedMergeTypes(ingredients);
    tempIng.ingredientIngredientType = getCombinedMergeIngIngTypes(tempIng, ingredients);
    setMergeIngredient(tempIng);
  };

  const onClickMergeStockHandler = async (props) => {
    mergedAndDeletedStockIds[props.excludedStockId] = props.mergeStock.id;
    setMergedAndDeletedStockIds({ ...mergedAndDeletedStockIds });
    await onClickMergeStock({
      ...props,
      mergedAndDeletedStockIds: mergedAndDeletedStockIds,
      setIsMerging: setIsMerging,
    });
  };

  const rMModalProps: RMModalProps = {
    showModal: showModal,
    body: (
      <div id="mergeingredients-rmmodalprops-wrapper">
        {isMerging && (
          <div id="mergeingredients-rmmodalprops-backdroploading" className=" z-[1400]">
            <FmlxBackdropLoading
              id="mergeingredients-rmmodalprops-backdroploading-mergingingredients"
              description="Merging ingredients..."
              show={true}
            />
          </div>
        )}
        <div id="mergeingredients-rmmodalprops-row" className="flex flex-direction-row">
          <div
            id="mergeingredients-rmmodalprops-ingredient1-container"
            className="border-box merge-ingredient-container w-1/3"
          >
            <div id="mergeingredients-rmmodalprops-ingredient1-wrapper">
              <MergeIngredientSection
                ingredient={ingredients.length > 0 && ingredients[0]}
                heading="Ingredient 1"
                buttonText="COPY ALL"
                onClickButton={onClickButton}
                showButtons={false}
                setTempIngredient={setTempIngredient}
                tempIngredient={tempIngredient}
                setMergeIngredientType={setMergeIngredientType}
                mergeIngredientType={mergeIngredientType}
                currentMergeIngredientType={MergeIngredientType.Ingredient1}
                setMergeIngredient={setMergeIngredient}
              />
            </div>
          </div>
          <div
            id="mergeingredients-rmmodalprops-ingredient2-container"
            className="border-box merge-ingredient-container w-1/3"
          >
            <div id="mergeingredients-rmmodalprops-ingredient2-wrapper">
              <MergeIngredientSection
                ingredient={ingredients.length > 0 && ingredients[1]}
                heading="Ingredient 2"
                buttonText="COPY ALL"
                onClickButton={onClickButton}
                showButtons={false}
                setTempIngredient={setTempIngredient}
                tempIngredient={tempIngredient}
                setMergeIngredientType={setMergeIngredientType}
                mergeIngredientType={mergeIngredientType}
                currentMergeIngredientType={MergeIngredientType.Ingredient2}
                setMergeIngredient={setMergeIngredient}
              />
            </div>
          </div>
          <div
            id="mergeingredients-rmmodalprops-mergeingredient-container"
            className="border-box merge-ingredient-container w-1/3"
          >
            <div id="mergeingredients-rmmodalprops-mergeingredient-wrapper">
              <MergeIngredientSection
                ingredient={mergeIngredient}
                onClickAdd={addMergeIngredient}
                onClickDelete={setMergeIngredient}
                heading="Merge Ingredient"
                buttonText="CLEAR ALL"
                onClickButton={onClickButton}
                showButtons={true}
                tempIngredient={tempIngredient}
                setMergeIngredientType={setMergeIngredientType}
                mergeIngredientType={mergeIngredientType}
                currentMergeIngredientType={MergeIngredientType.MergeIngredient}
                setMergeIngredient={setMergeIngredient}
              />
            </div>
          </div>
        </div>
        <div
          id="mergeingredients-rmmodalprops-buttons"
          className="p-1 float-right cursor-pointer"
        >
          <MergeIngredientsButtons
            setMergingStocks={setMergingStocks}
            setStockIndex={setStockIndex}
            ingredients={ingredients}
            mergeIngredient={mergeIngredient}
            setIngredients={setIngredients}
            setShowModal={setShowModal}
            setMergeIngredient={setMergeIngredient}
            setMatchedIngStocks={setMatchedIngStocks}
            matchedIngStocks={matchedIngStocks}
            mergedIngredient={mergeIngredient}
            stockIndex={stockIndex}
            setStocks={setStocks}
            setMatchedStocks={setMatchedStocks}
            setStocksShowModal={setStocksShowModal}
            dispatch={dispatch}
            ingTableDataIndicator={ingTableDataIndicator}
            excludedStockIds={[]}
            setIsMerging={setIsMerging}
          />
        </div>
        <MergeStocks
          ingredientName={
            ingredients.find((ing) => ing.id === stocks[0]?.ingredientId)?.longName
          }
          stockOne={stocks[0]}
          stockTwo={stocks[1]}
          setStocks={setStocks}
          showModal={showStocksModal}
          setShowModal={setShowModal}
          matchedStocks={matchedStocks}
          ingredients={ingredients}
          onClickMergeStock={onClickMergeStockHandler}
          mergeIngredient={mergeIngredient}
          matchedIngStocks={matchedIngStocks}
          setMergeIngredient={setMergeIngredient}
          setMatchedStocks={setMatchedStocks}
          setStockIndex={setStockIndex}
          stockIndex={stockIndex}
          setStocksShowModal={setStocksShowModal}
          setIsMerging={setIsMerging}
        />
      </div>
    ),
    setShowModal: setShowModal,
    heading: 'Merge Ingredients Options',
    showButtons: false,
    dialogClassName: 'ingredients-merge-modal',
    size: FmlxModal.Size.EXTRA_LARGE,
    onHide: () => {
      setIngredients([]);
      setShowModal(false);
      setStockIndex(0);
    },
  };
  return (
    <>
      <RMModal
        id="mergeingredients-modal-wrapper"
        showModal={rMModalProps.showModal}
        setShowModal={rMModalProps.setShowModal}
        body={rMModalProps.body}
        heading={rMModalProps.heading}
        showButtons={rMModalProps.showButtons}
        dialogClassName={rMModalProps.dialogClassName}
        size={rMModalProps.size || FmlxModal.Size.MEDIUM}
        onHide={rMModalProps.onHide}
      />
    </>
  );
};
